<bw-action-article-legacy [brightsideWebFb]="{event_name: 'savi_splash'}">
  <ui-nav-exit-back
    header-actions
    (exitActionHandler)="exitPage()"
    [trackingDetail]="{ event_name: 'savi_splash' }"
  ></ui-nav-exit-back>
  <div content-section>
    <div class="savi_splash_hdr">
      <typography-legacy text-xsmall-regular color="white" class="mb-sm">
        {{ 'SAVI_SPLASH_TYPE' | translate }}
      </typography-legacy>
      <typography-legacy title-large color="var(--blue-20)" style="font-size: 48px;line-height: 49px;">
        {{ 'SAVI_SPLASH_BIG_TITLE' | translate }}
      </typography-legacy>
    </div>
    <div class="mb-md">
      <div class="img-wrapper mb-sm"
        [style.background-image]="'url(' + bgImage + ')'">
      </div>
      <typography-legacy title-large>{{ 'SAVI_SPLASH_TITLE' | translate }}</typography-legacy>
    </div>
    <typography-legacy color="var(--secondary-text)">
      <bw-paragraph-legacy>
        {{ 'SAVI_SPLASH_DESC' | translate }}
      </bw-paragraph-legacy>
    </typography-legacy>
  </div>
  <div footer-actions class="flex-row flex-item-flexible space-between">

      <button
        bw-button-legacy
        [brightsideWebFb]="{event_name: 'savi_splash'}"
        (click)="goToSaviInfo()">
        {{ 'SAVI_SPLASH_BUTTON' | translate }}
      </button>

  </div>
</bw-action-article-legacy>


